var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_vm.isOpen ? _c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "backdrop cursor-pointer",
    on: {
      "click": _vm.closeModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content py-3 px-4 bg-white rounded-lg"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('span', {
    staticClass: "pull-right mb-0 text-right h2 font-weight-normal cursor-pointer close-button",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("✕")])]), _vm._v(" "), _vm._t("default")], 2)]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }